// extracted by mini-css-extract-plugin
export var error = "h_G";
export var fieldTitle = "h_F";
export var fiveStar = "h_H";
export var ratingContainer = "h_B";
export var ratingSpacer = "h_D";
export var ratingSubContainer = "h_C";